import React from 'react';
import { Profile } from '../../app/models/profile';
import { observer } from 'mobx-react-lite';
import { Card, Icon, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { FollowButton } from './FollowButton';

interface Props {
  profile: Profile;
}

const ProfileCard: React.FC<Props> = observer(({ profile }) => {
  const followersText = profile.followersCount === 1 ? 'follower' : 'followers';
  return (
    <Card as={Link} to={`/profiles/${profile.username}`}>
      <Image src={profile.image || '/assets/user.png'} />
      <Card.Content>
        <Card.Header>{profile.displayName}</Card.Header>
        <Card.Description>
          <p
            style={{
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
            }}
          >
            {profile.bio}
          </p>
        </Card.Description>
        <Card.Content extra>
          <Icon name="user" />
          {profile.followersCount} {followersText}
        </Card.Content>
      </Card.Content>
      <FollowButton profile={profile} />
    </Card>
  );
});

export { ProfileCard };
